import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ChangeCategoryDialogController',
            ChangeCategoryDialogController
        );

    /** @ngInject */
    function ChangeCategoryDialogController(
        $scope,
        $stateParams,
        CompaniesFactory,
        toastr,
        $state,
        ngDialog
    ) {
        var vm = this;

        init();

        function init() {
            vm.issue = $scope.ngDialogData.issue;
            vm.save = save;
        }

        function save() {
            CompaniesFactory.editIssue(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                { issue_category: vm.issue.issue_category }
            ).then(function () {
                toastr.success('Zapisano zmiany');
                ngDialog.close();
                $state.reload('company_employee.issue_list');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-category/change-category.controller.ts